<template>

  <v-container fluid class="pa-1">

    <v-app-bar fixed flat :style="{top:'60px'}">
      <v-tabs v-model="tabState" fixed-tabs>
        <v-tab
            v-for="state in orderStates"
            :key="state"
            active-class="secondary onSecondary--text"
            @click="refresh"
        >
          {{ $t('delivery.states.' + state) }}
          <v-chip class="ml-1 font-weight-black indigo--text text--darken-4"
                  v-if="getStateCount(state) > 0" small
                  color="indigo lighten-4">{{ getStateCount(state) }}
          </v-chip>
        </v-tab>
      </v-tabs>
      <v-spacer></v-spacer>
      <v-btn
          fab absolute right small color="teal" dark
          @click="refresh"
      >
        <v-icon>refresh</v-icon>
      </v-btn>
    </v-app-bar>

    <v-tabs-items v-if="show" v-model="tabState">
      <v-tab-item
          v-for="state in orderStates"
          :key="state"
          class="pt-12"
      >
        <v-row class="mt-3" no-gutters>
          <v-col cols="12" v-if="state === 'SCHEDULED'">
            <v-alert type="info">
              Pedidos que esten programados de <b>{{$store.getters.getSettingValue('TimeForOrderScheduled')}} hs</b> en adelante.
            </v-alert>
          </v-col>

          <v-col cols="12" sm="5" class="px-1">
            <v-card outlined>
              <v-card-title>
                {{$t('delivery.states.'+state)}}
              </v-card-title>
              <v-card-subtitle>TAKE_AWAY</v-card-subtitle>
                <order-flow-table
                    :ref="state"
                    :state="state"
                    mode="TAKE_AWAY"
                    :disable-headers="['delivery.distance','location.address', 'deliveryUser.username','orderType', 'addressOrName']"
                    @orderUpdatePrev="onOrderUpdatePrev"
                    @orderUpdateNext="onOrderUpdateNext"
                />
            </v-card>
          </v-col>
          <v-col cols="12" sm="7" class="px-1">
            <v-card outlined>
              <v-card-title>
                {{$t('delivery.states.'+state)}}
              </v-card-title>
              <v-card-subtitle>DELIVERY</v-card-subtitle>
                <order-flow-table
                    :ref="state"
                    :state="state"
                    mode="DELIVERY"
                    :disable-headers="['SCHEDULED','PENDING_RECEIPT','REVIEW','NEW','PREPARING'].includes(state) ? [ 'orderType','addressOrName','deliveryUser.username'] : ['orderType', 'addressOrName'  ]"
                    @orderUpdatePrev="onOrderUpdatePrev"
                    @orderUpdateNext="onOrderUpdateNext"
                />

            </v-card>
          </v-col>

        </v-row>



      </v-tab-item>
    </v-tabs-items>
    <print-ticket v-if="orderToPrint" ref="printer" hide :order="orderToPrint"></print-ticket>
  </v-container>

</template>

<script>
import OrderProvider from "@/modules/delivery/providers/OrderProvider";
import OrderFlowTable from "@/modules/delivery/components-core/business/OrderFlowTable/OrderFlowTable";
import PrintTicket from "@/modules/delivery/components-core/business/PrintTicket/PrintTicket";
import {mapGetters} from 'vuex'
import {ORDER_STATES} from "@/modules/delivery/constants/OrderStates";

export default {
  name: "OrderFlowPage",
  components: {PrintTicket, OrderFlowTable},
  data() {
    return {
      show: true,
      tabState: 0,
      orderGroupByState: [],
      orderToPrint: null
    }
  },
  mounted() {
    this.$store.dispatch('fetchCategories')
    this.loadOrderGroupByState()
  },
  computed: {
    ...mapGetters(['getLastOrderNumber']),
    getStateCount() {
      return state => {
        let r = this.orderGroupByState.find(e => e.state === state)
        return r ? r.count : 0
      }
    },
    orderStates(){
      return ORDER_STATES
    }
  },
  watch:{
    getLastOrderNumber(){
      this.refresh()
    }
  },
  methods: {
    loadOrderGroupByState() {
      OrderProvider.fetchOrderGroupByState(null,  ["TAKE_AWAY", "DELIVERY"])
          .then(resp => {
            this.orderGroupByState = resp.data.orderGroupByState
          })
    },
    refresh() {
      this.loadOrderGroupByState()
      this.show = false
      this.$nextTick(() => this.show = true)
    },
    onOrderUpdatePrev(){
      this.refresh()
    },
    onOrderUpdateNext(order){
      this.refresh()
      this.$nextTick( () => this.checkPrint(order) )
    },
    checkPrint(order){
      if(order.state === 'NEW'){
        this.orderToPrint = order
        this.$nextTick(()=> this.$refs.printer.print())
      }
    },
  }
}
</script>

<style scoped>

</style>
